import style from './PrivacyPolicy.module.css'

export default function PrivacyPolicy() {
    return (
        <div className="container  text-start pt-4 pb-5">
            <h5 className="mb-4 text-center">Privacy Policy</h5>

            <p className={style.text}>
                Your privacy is important to us at <strong>PeoplePulse</strong>. This
                Privacy Policy outlines how we collect, use, and protect your personal
                information.
            </p>

            <h5 className={style.title}>1. Information We Collect</h5>
            <p className={style.text}>
                We collect information that you provide directly, such as when you sign
                up, log in, or update your profile. We may also collect usage data such
                as browser type, pages visited, and time spent on our platform.
            </p>

            <h5 className={style.title}>2. How We Use Your Information</h5>
            <p className={style.text}>
                We use your data to manage accounts, provide services, improve user
                experience, and communicate important updates related to your account or
                the platform.
            </p>

            <h5 className={style.title}>3. Data Protection</h5>
            <p className={style.text}>
                We use encryption and secure protocols to protect your data from
                unauthorized access, alteration, or disclosure.
            </p>

            <h5 className={style.title}>4. Cookies</h5>
            <p className={style.text}>
                Cookies help us enhance your browsing experience. You can disable them
                in your browser settings, but some parts of the site may not function
                properly.
            </p>

            <h5 className={style.title}>5. Third-Party Services</h5>
            <p className={style.text}>
                We may use third-party tools (e.g., analytics or hosting) that collect
                limited information to help us operate and improve our services. These
                providers are required to maintain data confidentiality.
            </p>

            <h5 className={style.title}>6. Your Rights</h5>
            <p className={style.text}>
                You can request to view, correct, or delete your personal data at any
                time by contacting us.
            </p>

            <h5 className={style.title}>7. Updates to This Policy</h5>
            <p className={style.text}>
                This Privacy Policy may be updated periodically. We encourage users to
                check this page regularly to stay informed.
            </p>

            <h5 className={style.title}>8. Contact Us</h5>
            <p className={style.text}>
                For questions about this policy, reach out to{" "}
                <a href="mailto:privacy@peoplepulse.com">privacy@peoplepulse.com</a>.
            </p>
        </div>
    );
}
